import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/package";

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Add = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

export const Edit = async (values) => {
  return await axiosInstance(options).post(`${path}/edit`, values);
};

export const Status = async (values) => {
    return await axiosInstance(options).post(`${path}/change-status`, values);
};

export const Details = async (id) => {
  return await axiosInstance(options).get(`${path}/details?_id=${id}`);
};

export const Delete = async (values) => {
  console.log(values)
  return await axiosInstance(options).delete(`${path}/delete-package?_id=${values._id}`, values)
}



